module.exports = __webpack_public_path__ + "static/ss-942fb70cdd79c5f133cd6cba2feeb8ae.jpg";